import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const OAuthCallback: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');

      try {
        if (error) {
          // Handle OAuth error
          console.error('OAuth error:', error);
          if (window.opener) {
            window.opener.postMessage({
              type: 'oauth_error',
              error: error
            }, window.location.origin);
          }
          window.close();
          return;
        }

        if (code && state) {
          // Extract platform and user_id from state (format: user_id:platform_auth)
          const [_userId, platformState] = state.split(':');
          const platform = platformState.replace('_auth', '');

          // console.log('OAuth success:', { platform, code });

          // Send the authorization code back to the parent window
          if (window.opener) {
            window.opener.postMessage({
              type: 'oauth_success',
              platform: platform,
              code: code,
              state: state
            }, window.location.origin);
          }

          // Close the popup
          window.close();
        } else {
          console.error('Missing code or state parameter');
          if (window.opener) {
            window.opener.postMessage({
              type: 'oauth_error',
              error: 'Missing authorization code'
            }, window.location.origin);
          }
          window.close();
        }
      } catch (error) {
        console.error('Error handling OAuth callback:', error);
        if (window.opener) {
          window.opener.postMessage({
            type: 'oauth_error',
            error: 'Failed to process authorization'
          }, window.location.origin);
        }
        window.close();
      }
    };

    handleCallback();
  }, [location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mx-auto mb-4"></div>
        <h2 className="text-lg font-semibold text-gray-900 mb-2">Processing Authorization...</h2>
        <p className="text-gray-600">This window will close automatically.</p>
      </div>
    </div>
  );
};

export default OAuthCallback; 